export const API_HOST = "https://api.pokedex.crewbindrup.com";
